import { descriptionTypography } from "shared/styles/style"
import { noteTypography } from "shared/styles/style"
import { titleTypography } from "shared/styles/style"

// Modal style
export const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "fit-content",
  bgcolor: "background.paper",
  borderRadius: "15px",
  boxShadow: 24,
  outline: 0,
  padding: 3,
  maxWidth: 400,
}

// Custom style for Select component
export const customStyle = (disable) => ({
  minWidth: "150px",
  ...(disable && { backgroundColor: "#FAFAFA!important" }),
  borderRadius: "0.375rem",
  "& *": {
    fontFamily: "'Lexend', san-serif !important",
  },
  "& .MuiOutlinedInput-root": {
    paddingTop: "4px",
    paddingBottom: "4px",
  },
  "& input, & input::placeholder": {
    fontSize: "12px !important",
    lineHeight: "1.5!important",
    fontWeight: 400,
  },
  "& input": {
    paddingLeft: `14px !important`,
  },
})

// Calendar container styles
export const calendarContainer = ({ breakpoints, functions: { pxToRem } }) => ({
  width: "100%",
  height: "100%",
  boxShadow: ["0px 4px 4px 0px #00000040", "0px 2px 6px 0px #00000040"],
  borderRadius: pxToRem(20),
  padding: `${pxToRem(24)} ${pxToRem(16)} 0`,
  background: "#fff",
  position: "relative",
  minWidth: "100%",

  [breakpoints.up("xxl")]: {
    width: `calc(100% - 150px)`,
  },

  [breakpoints.up("xl")]: {
    width: `calc(100% - 120px)`,
  },

  [breakpoints.up("lg")]: {
    width: `calc(100% - 100px)`,
  },

  [breakpoints.up("md")]: {
    width: `calc(100% - 80px)`,
  },

  [breakpoints.down("md")]: {
    width: `calc(100% - 40px)`,
  },

  // CSS from custom.css
  "& thead .fc-scroller": {
    overflow: "hidden !important",
  },
  "& tbody .fc-scroller::-webkit-scrollbar": {
    display: "none !important",
  },
  "& .fc-day-today": {
    backgroundColor: "inherit !important",
  },
  "& .fc-v-event": {
    borderRadius: "8px",
    border: "none",
    padding: "8px",
    cursor: "pointer",
    minHeight: "32.5px",
  },
  "& .fc-timegrid-slots table": {
    borderRight: "1px",
  },
  "& .fc .fc-timegrid-slot": {
    borderRight: "0 !important",
  },
  "& .fc-v-event .fc-event-time": {
    display: "none",
  },
  "& .fc-v-event .fc-event-title-container": {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    textAlign: "left",
    color: "#000",
    fontFamily: "'Lexend', 'san-serif'",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "150%",
  },
  "& .fc-v-event .fc-event-title-container:focus": {
    zIndex: 100,
  },
  "& .fc-h-event": {
    border: "none !important",
  },
  "& .fc-daygrid-day-number": {
    fontSize: "16px",
    color: "#172b4d",
    fontWeight: 700,
  },

  // Media queries from custom.css
  "@media screen and (max-width: 1920px)": {
    "& .fc-v-event": {
      borderRadius: "4px",
      padding: "4px",
    },
  },
  "@media screen and (max-width: 1600px)": {
    "& .fc-daygrid-day-number": {
      fontSize: "13px",
    },
  },
  "@media screen and (max-width: 768px)": {
    "& .fc-v-event": {
      margin: "0px",
      padding: "2px",
    },
  },
})

export const calendarLoading = () => ({
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  background: "rgba(0, 0, 0, 0.15)",
  position: "absolute",
  zIndex: 99,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
})

export const calendarHeader = ({ breakpoints, functions: { pxToRem } }) => ({
  marginBottom: `${pxToRem(8)} !important`,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "8px",

  [breakpoints.down(1600)]: {
    marginLeft: 0,
  },

  [breakpoints.down("lg")]: {
    flexDirection: "column",
    alignItems: "flex-start",
    gap: pxToRem(16),
    margin: 0,
  },
})

export const calendarTitle = ({ breakpoints }) => ({
  ...titleTypography(breakpoints),
  lineHeight: 1.5,
  letterSpacing: 0,
  textAlign: "left",
  fontSize: "15px !important",

  [breakpoints.down("md")]: {
    fontSize: 12,
  },
})

export const calendarTabMenuItem = (
  { breakpoints, functions: { pxToRem } },
  { active }
) => ({
  borderRadius: pxToRem(8),
  height: pxToRem(35),
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer",
  padding: "8px 10px ",

  ...(active
    ? { background: "#ffffff", boxShadow: "0px 2px 6px 0px #00000040" }
    : {}),

  [breakpoints.down(1600)]: {
    height: pxToRem(30),
  },
})

export const calendarTabMenuItemTitle = ({ breakpoints }) => ({
  ...noteTypography(breakpoints),
  lineHeight: 1.25,
  textAlign: "center",
  fontSize: "14px !important",
  whiteSpace: "nowrap",
})

export const calendarUTCSelect = ({
  typography,
  breakpoints,
  functions: { pxToRem },
}) => ({
  position: "relative",
  display: "flex",
  width: pxToRem(140),
  height: pxToRem(40),
  borderRadius: "8px",
  overflow: "hidden",
  border: "1px solid #1576bc",

  "& select": {
    appearance: "none",
    border: "0",
    boxShadow: "none",
    outline: "none",
    flex: 1,
    padding: "0 1em",
    color: "#525f7f",
    backgroundColor: "white",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right 16px center",
    fontFamily: typography.lexendFont,
    fontSize: 16,
    fontWeight: 400,
    lineHeight: pxToRem(24),
    textAlign: "left",
    cursor: "pointer",
  },

  "& select::-ms-expand": {
    display: "none",
  },

  [breakpoints.down(1600)]: {
    width: pxToRem(120),
    height: pxToRem(34),

    "& select": {
      backgroundPosition: "right 8px center",
      fontSize: 12,
    },
  },
})

export const calendarTabMenuContainer = ({
  breakpoints,
  functions: { pxToRem },
}) => ({
  maxWidth: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: pxToRem(32),
  [breakpoints.down("lg")]: {
    flexDirection: "column",
    gap: pxToRem(12),
    alignItems: "flex-end",
  },
})

export const calendarTabMenu = ({ breakpoints, functions: { pxToRem } }) => ({
  maxWidth: "100%",
  borderRadius: "12px",
  padding: "4px",
  background: "#f6f9fc",
  display: "flex",

  [breakpoints.down(992)]: {
    width: "100%",
    margin: 0,
  },
  [breakpoints.down("lg")]: {
    width: "100%",
    justifyContent: "space-around",
  },
})

export const calendarDayHeader = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "center",
}

export const calendarDayTopHeader = (
  { breakpoints },
  { isWeekends, isToday }
) => ({
  ...descriptionTypography(breakpoints),
  lineHeight: 1.5,
  letterSpacing: "0em",
  textAlign: "center",
  color: isWeekends
    ? "#fd7e14 !important"
    : isToday
    ? "#32325d !important"
    : "#adb5bd !important",
})

export const calendarDayBottomHeader = (
  { breakpoints },
  { isWeekends, isToday }
) => ({
  ...descriptionTypography(breakpoints),
  lineHeight: 1.5,
  letterSpacing: "0em",
  textAlign: "center",
  fontWeight: isToday ? 700 : 400,
  color: isWeekends ? "#ffb647 !important" : isToday ? "#212529" : "#8898aa",
})

export const calendarSlotLabel = ({ breakpoints }) => ({
  ...descriptionTypography(breakpoints),
  lineHeight: 1.5,
  letterSpacing: "0em",
  textAlign: "center",
  color: "#212529",
  fontSize: "14px !important",
})

export const calendarDayNumberText = ({ breakpoints }) => ({
  cursor: "pointer",
  transition: "all 0.2s ease-in-out",
  display: "inline-block",
  width: "25px",
  height: "25px",
  lineHeight: "25px",
  textAlign: "center",
  borderRadius: "50%",
  "&:hover": { Opacity: 0.7 },
})

export const modalHeaderStyle = {
  display: "flex",
  gap: 1,
  alignItems: "center",
  mb: 3,
}

export const modalIconContainerStyle = {
  width: 48,
  height: 48,
  background: "#2576B9",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "8px",
}

export const modalButtonContainerStyle = {
  mt: 3,
  color: "#FFFFFF",
  fontFamily: "Lexend, san-serif",
  textTransform: "unset",
  width: "350px",
  maxWidth: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: 2,
}

export const modalButtonStyle = {
  mt: 3,
  color: "#FFFFFF",
  backgroundColor: "#2576B9",
  fontFamily: "Lexend, san-serif",
  textTransform: "unset",
  width: "-webkit-fill-available",
}

export const viewOptionsContainerStyle = {
  display: "flex",
  background: "gray",
  borderRadius: "4px",
  overflow: "hidden",
  height: "40px",
  display: "flex",
  alignItems: "center",
  borderRadius: "8px",
}

export const viewOptionStyle = (isActive) => ({
  background: isActive ? "#192d3d" : "#2576B9",
  padding: "6px 12px",
  cursor: "pointer",
  height: "100%",
  display: "flex",
  alignItems: "center",
})

export const eventModalContentStyle = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  gap: 1,
}

export const dayCellStyle = (isActiveDayOff, viewMode) => ({
  width: "25px",
  height: "25px",
  lineHeight: "25px",
  textAlign: "center",
  borderRadius: "50%",
  backgroundColor: "#EC221F",
  color: "#ffffff",
  cursor: "pointer",
  "&.activeDayOff": {
    backgroundColor: "#AFF4C6",
    color: "#344767",
  },
})

export const searchTeacherInputStyle = {}
